/* eslint-disable import/extensions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');

const { useEffect, useState } = React;

function AnchoredLanding(props) {
  const { i18n, htmlContent } = props;
  const [showAnchoredMenu, setShowAnchoredMenu] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    try {
      const h2sList = document?.getElementsByTagName('h2');
      const validationAnchoredMenu = (h2sList?.length >= 2 && h2sList?.length < 15);
      setShowAnchoredMenu(validationAnchoredMenu);
      const arry = Array.from(h2sList);
      setData(arry);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }, [htmlContent]);

  return (
    <nav className={`anchored-menu anchor-mobile ${showAnchoredMenu ? '' : 'hidden'}`}>
      <div className="anchored-menu-box">
        <p>{`${i18n.gettext('PUEDES PROBAR')}`}</p>
        <div id="anchor-container-list" className="anchored-menu-landing">
          {data && data.map((element) => (
            <li className="anchored-menu-landing-li"><a className="anchored-menu-landing-a" href={element.id}>{element.innerHTML}</a> </li>
          ))}
        </div>
      </div>
    </nav>
  );
}

AnchoredLanding.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
};

AnchoredLanding.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = AnchoredLanding;
